module.exports = __webpack_public_path__ + "img/finance-home.8acdd2f5.jpg";